import { getOrganizationNameFromHostname } from "./getOrganizationNameFromHostname";

export const isAppHostname = () => getOrganizationNameFromHostname() === "app";
